import { initTranslations } from '@futures-platform/i18n'

const localTranslations = {
    pptxTimestamp: {
      en: 'Timestamp',
      fi: 'Ajankohta'
    },
    pptxCommentsTitle: {
      en: 'Comments',
      fi: 'Kommentit'
    },
    pptxCommentsText: {
      en: count => `There are ${count === 0 ? 'no' : count } comment${count !== 1 ? 's' : ''} on this radar. To review them${count === 0 ? ' later': ''}, please log in to the platform and click this link: `,
        fi: count => count === 0 ? 'Kartalle ei ole vielä käyttäjien kommentteja. Pääset katsomaan niitä myöhemmin kirjautumalla palveluun ja klikkaamalla tätä linkkiä: ' : `Kartalla on yhteensä ${count} käyttäjien kommentti${count > 1 ? 'a' : ''}. Pääset katsomaan niitä kirjautumalla palveluun ja klikkaamalla tätä linkkiä: `
    },
    download: {
        en: 'Download',
        fi: 'Lataa'
    },
    downloadPPTXDescription: {
        en: 'Download radar summary in PowerPoint format.',
        fi: 'Lataa yhteenveto PowerPoint-muodossa.'
    },
    pptxGenerateReport: {
        en: 'Download summary (ppt)',
        fi: 'Lataa yhteenveto (ppt)'
    },
    generatingPPTXError: {
        en: `generating PowerPoint`,
        fi: `raporttia luodaan`
    },
    pptxNotVoted: {
      en: 'Not voted',
      fi: 'Ei ääniä'
    },
    pptxReportBy: {
      en: 'by',
      fi: '-'
    },
    pptxSectorListTitle: {
      en: 'List of Sectors',
      fi: 'Sektorit'
    },
    pptxRatedContent: {
        en: 'Rated Content',
        fi: 'Arvioitu sisältö'
    },
    pptxReportTitle: {
        en: 'Content Summary',
        fi: 'Yhteenveto'
    },
    pptxSector: {
        en: 'Sector',
        fi: 'Sektori'
    },
    pptxSectorContent: {
        en: 'Content in the Sector',
        fi: 'Sektorin sisältö'
    },
    pptxTopVotedContent: {
        en: 'Top-Voted Content',
        fi: 'Äänestetyt ilmiöt'
    },
    timelineModeTitle: {
        en: `Please confirm you want to switch the label format`,
        fi: `Haluatko, että haluat muuttaa aikajanan formaattia`
    },
    timelineModeSubtitle: {
        en: ``,
        fi: ``
    },
    timelineDeleteTitle: {
        en: year => `Delete ${year}?`,
        fi: year => `Poista ${year}?`
    },
    deleteBtn: {
        en: `Delete`,
        fi: `Poista`
    },
    timelineDeleteSubtitle: {
        en: `You're about to remove this time range. The content on the radar will not be removed, it will be re-organised according to the remaining ranges. Do you want to continue??`,
        fi: `Olet poistamassa aikakehää. Sen sisältöä ei poisteta, vaan se järjestetään uudelleen jäljelle jäävien kehien mukaisesti. Haluatko jatkaa?`
    },
    addTimelineButton: {
        en: `+ ADD NEW RANGE`,
        fi: `+ LISÄÄ UUSI KEHÄ`
    },
    deleteSignalConfirmation: {
        en: 'Are you sure?',
        fi: 'Oletko varma?'
    },
    description: {
        en: `Description`,
        fi: `Kuvaus`
    },
    year: {
        en: `Year`,
        fi: `Vuosi`
    },
    add: {
        en: `Add`,
        fi: `Lisää`
    },
    timerangeBoundaryError: {
        en: ({ firstYear, lastYear }) => `Please enter a valid input between ${firstYear} and ${lastYear}`,
        fi: ({ firstYear, lastYear }) => `Syötä vuosi väliltä  ${firstYear} ja ${lastYear}`,
    },
    timerangeSpaceError: {
        en: ({ previousYear, nextYear }) => `There's not enough space between ${previousYear} and ${nextYear} on your timerange. Please adjust your time ranges`,
        fi: ({ previousYear, nextYear }) => `Vuosien ${previousYear} ja ${nextYear} välillä ei ole tilaa uudelle kehälle. Tee väliin tilaa (vuosilukuina) ja yritä uudestaan`,
    },
    timerangeAmountError: {
        en: `You have reached the maxiumum amount of timeranges, please remove a timerange before trying to add a new one.`,
        fi: `Kartalle ei mahdu useampia kehiä. Voit poistaa yhden lisätäksesi uuden tai nimetä nykyiset kehät uudelleen.`
    },
    timerangeError: {
        en: `Please enter a valid input`,
        fi: `Syötä vuosiluku`
    },
    timerangeSmallerYearError: {
        en: nextYear => `Please enter a year smaller than ${nextYear}`,
        fi: nextYear => `Syötä vuosiluku ennen vuotta ${nextYear}`,
    },
    timerangeLargerYearError: {
        en: previousYear => `Please enter a year larger than ${previousYear}`,
        fi: previousYear => `Syötä vuosiluku ${previousYear} jälkeen`,
    },
    timerangeCurrentYearError: {
        en: currentYear => `Please enter a year after ${currentYear}`,
        fi: currentYear => `Syötä vuosiluku ${currentYear} jälkeen`,
    },
    timelineEditor: {
        en: `Timerange editor`,
        fi: `Aikajakson muokkaus`
    },
    updatingTimelinesPositionError: {
        en: `updating your timerange's position`,
        fi: `päivitetään aikajakson sijaintia`
    },
    removingTimelineError: {
        en: `removing your timerange`,
        fi: `poistetaan aikajakso`
    },
    addingTimelineError: {
        en: `adding your timerange`,
        fi: `lisätään aikajakso`
    },
    timerangeExistsError: {
        en: `This timerange already exists!`,
        fi: `Tämä aikajakso on jo olemassa!`
    },
    label: {
        en: `Label`,
        fi: `Kehän nimi`
    },
    typeLabel: {
        en: 'Type label',
        fi: 'Tyypin nimi'
    },
    labelPosition: {
        en: 'Label position',
        fi: 'Kehän nimen sijainti'
    },
    afterLabel: {
        en: previousLabel => `Below ${previousLabel}`,
        fi: previousLabel => `Alapuolelle ${previousLabel}`
    },
    consecutiveYearError: {
        en: 'The years behind these labels are consectuive, please switch back to year format and adjust for space before continuing',
        fi: 'Vuosileimat kehien nimien taustalla ovat peräkkäiset. Palauta aikajana vuosi-formaattiin ja tee tilaa ennen kuin jatkat.'
    },
    filterPhenomena: {
        en: `Filter content`,
        fi: `Suodata sisältö`
    },
    goToHub: {
        en: 'Open the hub',
        fi: 'Avaa Hub'
    },
    moreInfoHub: {
        en: 'For more info go to the hub',
        fi: 'Lisää tietoa löydät HUBista (englanniksi)'
    },
    toggleTimelineMode: {
        en: `Use text labels instead of years`,
        fi: `Käytä tekstiä vuosiluvun sijaan`
    },
    done: {
        en: `DONE`,
        fi: `VALMIS`
    },
    confirm: {
        en: `CONFIRM`,
        fi: `MUOKKAA`
    },
    cancel: {
        en: `CANCEL`,
        fi: `PERUUTA`
    },
    filterByType: {
        en: `BY TYPE`,
        fi: `TYYPIT`
    },
    filterByTag: {
        en: `BY TAG`,
        fi: `TAGIT`
    },
    openPublicLink: {
        en: `SHOW THE SHARED LINK`,
        fi: `NÄYTÄ JAETTAVA LINKKI`
    },
    createPublicLink: {
        en: `CREATE A SHARED LINK`,
        fi: `LUO JAETTAVA LINKKI`
    },
    publicLink: {
        en: `Shared Link`,
        fi: `Jaettava linkki`
    },
    publicLinkNote: {
        en: `Shared link provides anonymous access to the radar. Anyone with the shared link can access and collaborate on the radar. For data privacy reasons, we recommend deactivating the shared link when it's not used.`,
        fi: `Jaettava linkki tarjoaa anonyymin pääsyn valitulle kartalle. Linkkiä klikkaamalla kuka tahansa pääsee kartalle ja voiosallistua työskentelyyn. Tietoturvasyistä suosittelemme jaettavan linkin aktivointia vain kun sitä tarvitaan.`
    },
    regeneratePublicLink: {
        en: `REGENERATE LINK`,
        fi: `LUO UUSI LINKKI`
    },
    deletePublicLink: {
        en: `DELETE THE SHARED LINK`,
        fi: `POISTA JAETTAVA LINKKI`
    },
    publicLinkURL: {
        en: `Shared link: `,
        fi: `Jaettava linkki:`
    },
    regeneratePublicLinkNote: {
        en: `Note! Regenerating the link will deactivate the current link.`,
        fi: `Huom. Uuden linkin luonti poistaa nykyisen linkin toiminnasta.`
    },
    deletePublicLinkBtn: {
        en: `DELETE THE CURRENT SHARED LINK`,
        fi: `POISTA NYKYINEN JAETTU LINKKI`
    },
    sharePublicLinkConfirmation: {
        en: `Are you sure you want to regenerate a shared link?`,
        fi: `Haluatko varmasti luoda uuden jaettavan linkin?`
    },
    sharePublicLinkConfirmationNote: {
        en: `The current link will stop working when you create a new one.`,
        fi: `Nykyinen linkki lakkaa toimimasta, kun luot uuden.`
    },
    deletePublicLinkConfirmation: {
        en: `Are you sure you want to delete the shared link?`,
        fi: `Haluatko varmasti poistaa jaettavan linkin?`,        
    },
    deletePublicLinkConfirmationNote: {
        en: `When you delete the shared link, the radar remains visible to the users who have been granted access to the radar in the user management.`,
        fi: `Poistettuasi jaetun linkin tämä kartta näkyy vain henkilöille, joille on käyttäjähallinnassa annettu sille pääsy.`
    },
    copyToClipboard: {
        en: `Copy to clipboard`,
        fi: `Kopioi leikepöydälle`
    },
    publicLinkCopied: {
        en: `Link copied.`,
        fi: `Linkki kopioitu.`
    },
    shareRadarFromUsrMngmt: {
        en: `You can invite users to this radar from the User management, or by creating a Shared link and share that in your network. If you choose to create a Shared link, please note, that anyone with the link can access the radar and collaborate on it.`,
        fi: `Voit kutsua kollegasi kartalle käyttäjähallinnasta tai tehdä jaettavan linkin ja jakaa sen verkostossasi. Huomaathan, että jakamaasi linkkiä klikkaamalla kuka tahansa voi päästä kartalle ja osallistua työskentelyyn.` 
    },
    publicLinkExisted : {
        en: `A shared link already exists for this radar. Click below to view it.`,
        fi: `Tälle kartalle on tehty jaettava linkki. Voit katsoa sen alta.`
    },
    checkPublicLinkAlreadyExisted: {
        en:`A shared link already exists for this radar. Click below to view it.`,
        fi:`Tälle kartalle on tehty jaettava linkki. Voit katsoa sen alta.`
    },
    goToManagement: {
        en:`OPEN THE USER MANAGEMENT`,
        fi:`AVAA KÄYTTÄJÄHALLINTA`
    },
    ok: {
        en:`OK`,
        fi:`OK`
    },
    sharedLinkDeletedNote: {
        en:`The shared link is now deleted from this radar.`,
        fi:`Jaettava linkki on nyt poistettu tältä kartalta.`
    },
    upvotesForHaloDescription: {
        en:`Sum of votes required for 'halo' effect`,
        fi:`Sädekehään vaadittava äänimäärä`
    },
    createFormDiscussionDescription: {
        en: ` Enable Discussion area in the Collaboration results section`,
        fi: ` Aktivoi keskustelupalsta tulosten yhteenvetonäkymässä`
    },
    verticalAxisName: {
        en:`Vertical axis name`,
        fi:`Pystyakselin nimi`
    },
    HorizontalAxisName: {
        en:`Horizontal axis name`,
        fi:`Vaaka-akseli`
    },
    IntructionsForNamingAxis: {
        en:`You can select the commonly used axis from the pulldown menu, and/or fill in the fields manually. `,
        fi:`You can select the commonly used axis from the pulldown menu, and/or fill in the fields manually. `
    },
    FlipHorizontalVertical: {
        en:`FLIP HORIZONTAL/VERTICAL`,
        fi:`VAIHDA VAAKA- JA PYSTYAKSELIT`
    },
    clearAllFieldsBtn: {
        en:`CLEAR ALL FIELDS`,
        fi:`TYHJENNÄ KAIKKI KENTÄT`
    },
    editManuallyBtn: {
        en:`EDIT MANUALLY`,
        fi:`MUOKKAA KÄSIN`
    },
    InfoIconHoverVoting: {
        en:`"More information on Voting"`,
        fi:`"Lisätietoja äänestämisestä"`
    },
    InfoIconHoverRating: {
        en:`"More information on Rating"`,
        fi:`"Lisätietoja arvioinnista"`
    },
    InfoIconHoverCommenting: {
        en:`"More information on Commenting"`,
        fi:`"Lisätietoja kommentoinnista"`
    },
    InfoIconHoverDiscussion: {
        en:`"More information on Discussion area"`,
        fi:`"Lisätietoja keskustelupalstasta"`
    },
    InfoModalVotingNote: {
        en: `The Voting tool enables voting of the content on the radar together with your team or with other stakeholders.`,
        fi:`Voit äänestää kartalla olevaa sisältöä yhdessä tiimisi kanssa tai osallistamalla muita sidosryhmiäsi.`
        
    },

    InfoModalVotingContent: {
        en:`
         After activating the Voting tool, anyone with access to the radar can vote on the content cards.`,
        fi:`
         Aktivoituasi äänestyksen kaikki, joilla on pääsy kartalle, voivat äänestää ennakointikartalla olevaa sisältöä.`
    },
    InfoModalVotingContent2: {
        en:`
         It activates ‘up’ and ‘down’ arrows on the top-right corner of Content cards.
        `,
        fi:`
         Äänestyksessä jokaisen sisältökortin oikeaan yläkulmaan ilmestyvät nuolet ylös- ja alaspäin.
        `
    },
    InfoModalVotingContent3: {
        en:`
         You are able to decide the voted question, e.g. prioritising the "10 most impactful" or "5 least important".`,
        fi:`
         Voit päättää kysymyksen asettelun osallistujille, esimerkiksi priorisoiden "10 vaikuttavinta" tai "5 vähiten tärkeintä".`
    },
    InfoModalVotingContent4: {
        en:`
         When the set threshold of votes for the 'halo' effect is reached, it displays a light circle around the content dot on the radar.`,
        fi:`
         Halutessasi voit määrittää rajan sille, kuinka monta ääntä sisältökortti tarvitsee, jotta se saa karttanäkymässä ympärilleen sädekehän.`
    },
    InfoModalVotingContent5: {
        en:`
          After the voting activity, results of the voting can be found by clicking the centre of the radar.`,
        fi:`
         Äänestyksen jälkeen löydät äänestyksen tulokset painamalla kartan keskustaa.`
    },
    InfoModalVotingContent6: {
        en:`
          A summary of votes can be exported from the results view.`,
        fi:`
         Äänestys-sivulta voit ladata äänestyksen yhteenvedon jatkohyödyntämistä varten.`
    },
    InfoModalVotingContent7: {
        en:`
         Remember to Save your settings after you have made changes. If you wish to discard the changes you made, click Cancel.
        `,
        fi:`
          Muistathan tallentaa tekemäsi valinnat. Mikäli haluat poistua tallentamatta, paina Peruuta.`
    },
    LearnMoreFromHUB: {
        en:`
         Learn more from the HUB:
        `,
        fi:`
          Lisätietoja HUBista (sisältö englanniksi):`
    },
    
    LearnMoreVotingBtn: {
        en:`How the Voting system works in Futures Platform?`,
        fi: `How the Voting system works in Futures Platform?`
    },
    GuideVotingBtn: {
        en:`How to organise a Voting session in practise, and why?`,
        fi: `How to organise a Voting session in practise, and why?`
    },
    InfoModalRatingNote: {
        en:`The Rating tool enables evaluation and assessment of the content on the radar via two axis, and displays the results in a fourfold table.`,
        fi: `Arviointityökalu mahdollistaa sisällön arvioinnin kahdella akselilla visualisoiden arvioinnin tulokset nelikentässä.
        `
    },
    InfoModalRatingContent: {
        en:`
         After activating the Rating tool, anyone with access to the radar can rate on the content cards.`,
        fi:`
         Aktivoituasi arvioinnin kaikki, joilla on pääsy kartalle, voivat arvioida ennakointikartalla olevaa sisältöä.`
    },
    InfoModalRatingContent2: {
        en:`
         Activating Rating tool activates two 'axis sliders' on each content card.`,
        fi:`
         Arvioinnissa jokaiselle sisältökortille ilmestyy kaksi liukusäädintä.`
    },
    InfoModalRatingContent3: {
        en:`
         Access some of the most commonly used axis from the dropdown menu, and/or fill in custom axis names manually.`,
        fi:`
         Voit hyödyntää pudostusvalikosta löytyviä usein käytettyjä akseleita ja/tai voit nimetä akselit vapaasti itse.`
    },
    InfoModalRatingContent4: {
        en:`
          After the rating activity, results can be found by clicking the centre of the radar.`,
        fi:`
         Arvioinnin jälkeen löydät arvioinnin tulokset painamalla kartan keskustaa.`
    },
    InfoModalRatingContent5: {
        en:`
         A summary of ratings can be exported from the results view.
        `,
        fi:`
         Arviointi-sivulta voit ladata arviointien yhteenvedon jatkohyödyntämistä varten.`
    },
    InfoModalRatingContent6: {
        en:`
         Remember to Save your settings after you have made changes. If you wish to discard the changes you made, click Cancel.
        `,
        fi:`
         Muistathan tallentaa tekemäsi valinnat. Mikäli haluat poistua tallentamatta, paina Peruuta.
        `
    },
    LearnMoreRatingBtn: {
        en:`How the Rating system works in Futures Platform?`,
        fi: `How the Rating system works in Futures Platform?`
    },
    GuideRatingBtn: {
        en:`How to organise a Rating session in practise, and why?`,
        fi: `How to organise a Rating session in practise, and why?`
    },
    InfoModalCommentingNote: {
        en:`The Commenting tool enables collection of insights, ideas and thoughts on the content cards. `,
        fi: `Kommentointi mahdollistaa havaintojen, ideoiden sekä ajatusten keräämisen sisältökorteille.`
    },
    InfoModalCommentingContent: {
        en:`
         After activating the Commenting tool, anyone with access to the radar can leave their comments on the content cards..
        `,
        fi: `
         Aktivoituasi kommentoinnin kaikki, joilla on pääsy kartalle, voivat kommentoida ennakointikartalla olevaa sisältöä.
        `
    },
    InfoModalCommentingContent2: {
        en:`
         It activates three commenting fields on the content cards: Opportunities, Threats and Actions.`,
        fi: `
         Kommentteja voi kirjoittaa kolmeen kenttään: Mahdollisuudet, Uhat ja Toimenpiteet.`
    },
    InfoModalCommentingContent3: {
        en:`
         All comments are gathered to the results view which you can access by clicking the centre of the radar.`,
        fi: `
         Kaikki kommentit koostetaan Kommentit-sivulle, jolle pääset painamalla kartan keskustaa.`
    },
    InfoModalCommentingContent4: {
        en:`
         A summary of comments can be exported from the results view.`,
        fi: `
          Kommentit-sivulta voit ladata kommenttien yhteenvedon jatkohyödyntämistä varten.`
    },
    LearnMoreCommentingBtn: {
        en:`How the Commenting system works in Futures Platform?`,
        fi: `How the Commenting system works in Futures Platform?`
    },
    GuideCommentingBtn: {
        en:`How to organise a Commenting session in practise, and why?`,
        fi: `How to organise a Commenting session in practise, and why?`
    },
    InfoModalDiscussionNote: {
        en:`Allow free conversation, ask for feedback, or collect other notes regarding the foresight radar / topic you are working with.`,
        fi: `Keskustelupalsta on paikka vapaalle keskustelulle, palautteen keräämiselle tai muiden havaintojen tallentamiselle.
        `
    },
    InfoModalDiscussionContent: {
        en:`
         Activate the discussion board on the Collaboration results view which you can access by clicking the centre of the radar.
        `,
        fi: `
         Voit aktivoida keskustelupalstan tulosten yhteenvetonäkymän vasempaan laitaan, johon pääset painamalla kartan keskustaa.
        `
    },
    InfoModalDiscussionContent2: {
        en:`
         The discussion area can be used to discuss on Voting, Rating and Commenting results, or to collect any other kind of notes regarding the radar.`,
        fi: `
         Keskustelupalstalla voi keskustella äänestämisen, arvioinnin tai kommentoinnin tuloksista, ja siihen voi kerätä vapaasti kommentteja ja ajatuksia.`
    },
    InfoModalDiscussionContent3: {
        en:`        
         The discussion on the Discussion area can be exported from the results view.`,
        fi: `
         Tulosten yhteenvetonäkymästä voit ladata keskustelut jatkohyödyntämistä varten.`
    },
    LearnMoreDiscussionBtn: {
        en:`How the Discussion area works in Futures Platform?`,
        fi: `How the Discussion area works in Futures Platform?`
    },
    GuideDiscussionBtn: {
        en:`How to organise a Discussion in practise, and why?`,
        fi: `How to organise a Discussion in practise, and why?`
    },
    commenting: {
        en:`Commenting`,
        fi: `Kommentointi`
    },
    CommentingTool: {
        en:`Commenting tool`,
        fi: `Kommentointi`
    },
    RatingTool: {
        en:`Rating tool`,
        fi: `Arviointi`
    },
    VotingTool: {
        en:`Voting tool`,
        fi: `Äänestys`
    },
    DiscussionAreaTool: {
        en:`Discussion area`,
        fi: `Keskustelupalsta`
    },
    discussion: {
        en: `Discussion area`,
        fi: `Keskustelupalsta`
    },
    activateUsers: {
        en:`Collaboration tools`,
        fi: `Toiminnot`
    },
    createFormVotingDescription: {
        en:`Enable Voting on Content cards`,
        fi: `Salli äänestys sisältökorteilla`
    },
    upvotesForHalo: {
        en:`Enable 'halo' effect on the Radar`,
        fi: `Salli sädekehät karttanäkymässä`
    },
    createFormRatingDescription: {
        en:`Enable two axis Rating on Content cards (fourfold table)`,
        fi: `Aktivoi arviointi sisältökorteilla (nelikenttä)`
    },
    selectValue: {
        en:`Select...`,
        fi: `Valitse...`
    },
    manualEditLeftEnd: {
        en:`Horizontal axis – Left end`,
        fi: `Vaaka-akseli – vasen`
    },
    manualEditRightEnd: {
        en:`Horizontal axis – Right end`,
        fi: `Vaaka-akseli – oikea`
    },
    manualEditLowEnd: {
        en:`Vertical axis – Low end`,
        fi: `Pystyakseli – ala`
    },
    manualEditHighEnd: {
        en:`Vertical axis – High end`,
        fi: `Pystyakseli –  ylä`
    },
    manualEditTopLeft: {
        en:`Fourfold table – top left`,
        fi: `Nelikenttä – vasen yläosa`
    },
    manualEditTopRight: {
        en:`Fourfold table – top right`,
        fi: `Nelikenttä – oikea yläosa`
    },
    manualEditBottomLeft: {
        en:`Fourfold table – bottom left`,
        fi: `Nelikenttä – vasen alaosa`
    },
    manualEditBottomRight: {
        en:`Fourfold table – bottom right`,
        fi: `Nelikenttä – oikea alaosa`
    },
    createFormCommentingDescription: {
        en:`Enable Commenting on Content cards`,
        fi: `Aktivoi kommentointikentät sisältökorteilla`
    },
    allowLikeCommenting: {
        en:`Enable Liking other users’ comments`,
        fi: `Salli käyttäjien tykätä toistensa kommenteista`
    },
    GotItBtn: {
        en:`GOT IT`,
        fi: `OK`
    },
    DoneBtn: {
        en:`DONE`,
        fi: `VALMIS`
    },
    ConfirmationClearAllModal: {
        en:`Are you sure to clear all fields ?`,
        fi: `Haluatko varmasti tyhjentää kaikki kentät ?`
    },
    max40Chars: {
        en: `(max. 40 characters)`,
        fi: `(Enintään 40 merkkiä)`
    },
    yesBtn: {
        en: `YES`,
        fi: `KYLLÄ`
    },
    noBtn: {
        en: `NO`,
        fi: `EN`
    },
    closeCollabToolNote: {
        en: `Do you really want to close this window without saving?`,
        fi: `Haluatko varmasti sulkea tämän ikkunan tallentamatta muutoksia?`
    },
    hasTagged: {
        en: `: Yes`,
        fi: `: On`
    },
    hasNoTagged: {
        en: `: No`,
        fi: `: Ei ole`
    },
    TagsPhenomenon: {
        en: `Tags`,
        fi: `Tageja`
    },
    AddAndRemoveTags: {
        en: `Add / remove tags`,
        fi: `Lisää / poista tageja`
    },
    TagsAddedAfterContentcardCreated: {
        en: `Tags can be added after the content card is created.`,
        fi: `Voit lisätä sisältökortille tageja, kun olet ensin luonut (tallentanut) sen.`
    },
    AskingSaveTagsInEditorMode: {
        en: `You can now select the most suitable tags to the content. When done, please remember to SAVE your work!`,
        fi: `Tästä voit valita sisällöllesi sopivia tageja. Kun olet valmis, muista TALLENTAA työsi!`
    },
    SaveBtnInEditorMode: {
        en: `SAVE`,
        fi: `TALLENNA`
    },
    TitleTaggingSelector: {
        en: `Add / remove tags`,
        fi: `Lisää / Poista tageja`
    },
    deleteSectorConfirmationMainText: {
        en: `Are you sure you want to delete this sector?`,
        fi: `Haluatko varmasti poistaa sektorin?`
    },
    deleteSectorConfirmationSubText: {
        en: `This action can not be undone.`,
        fi: `Tätä toimintoa ei voi perua.`
    },
    inviteUsersToRadar: {
        en: `Invite users to the radar`,
        fi: `Kutsu kollegasi kartalle`
    },
    copyTheSharedLink: {
        en: `Manage the shared link`,
        fi: `Muokkaa jaettavaa linkkiä`
    },
    ShareRadar: {
        en: `Share radar`,
        fi: `Jaa kartta`
    },
    ShareRadar2Ways: {
        en: `You can share the radar in two ways:`,
        fi: `Voit antaa pääsyn kartalle kahdella tavalla:`
    },
    InviteUsers2Radars: {
        en: `Invite users to the radar`,
        fi: `Kutsu kollegasi kartalle`
    },
    InviteUsers2RadarsDescription: {
        en: `You can invite users to the radars in the user management. Each user will get a personal user account and an access to the selected radars.`,
        fi: `Käyttäjähallinnassa voit kutsua kartalle kollegojasi. Uusille ryhmän jäsenille avataan henkilökohtainen käyttäjätili ja he saavat pääsyn valituille kartoille.`
    },
    Or: {
        en: `OR`,
        fi: `TAI`
    },
    RequestAShareLink: {
        en: `Create a shared link`,
        fi: `Luo jaettava linkki`
    },
    RequestAShareLinkDescription: {
        en: `To give anonymous access to the radar for several external people, you can request a shared link. Anyone with a shared link can access the radar and collaborate on it. In addition, you can request an ”embed code” that makes it possible to embed the radar as iframe to digital platforms like webpages etc.`,
        fi: `Halutessasi voit tarjota pääsyn kartalle myös organisaationne ulkopuolisille henkilöille tilaamalla julkisesti jaettavan linkin. Linkkiä klikkaamalla kuka tahansa pääsee anonyymisti kartalle ja voi osallistua yhteistyöhön. Voit myös tilata upotuskoodin, jonka avulla kartan voi upottaa osaksi jotain toista digitaalista ympäristöä, esimerkiksi verkkosivua. PYYDÄ JAETTAVA LINKKI`
    },
    Close: {
        en: `CLOSE`,
        fi: `SULJE`
    },
    Sharingtheradar: {
        en: `Sharing the radar`,
        fi: `Kartalle pääsy`
    },
    Theradarcanbesharedintwoways: {
        en: `The radar can be shared in two ways.`,
        fi: `Kartalle pääsyn voi järjestää kahdella tavalla.`
    },
    UserManagementDescriptionLabel: {
        en: `Open the user management and invite your colleagues to the radar`,
        fi: `Avaa käyttäjähallinta ja kutsu kollegasi kartalle`
    },
    UserManagementDescription1: {
        en: `Invite either existing or new members`,
        fi: `Voit kutsua nykyisiä tai uusia jäseniä`
    },
    UserManagementDescription2: {
        en: `Each one will get a personal email invitation and an user account (if that doesn’t exist)`,
        fi: `Kukin heistä saa henkilökohtaisen kutsun sähköpostiin sekä käyttäjätunnuksen, jos sellaista ei vielä ole`
    },
    UserManagementDescription3: {
        en: `You can select a suitable role for everyone`,
        fi: `Voit antaa kullekin haluamasi tasoisen käyttäjäroolin`
    },
    UserManagementDescription4: {
        en: `Group members can access the Content explorer`,
        fi: `Ryhmän jäsenet pääsevät kartan lisäksi myös sisältöhakuun`
    },
    RequestSharedLinkLabel: {
        en: `Create a shared link`,
        fi: `Luo jaettava linkki`
    },
    RequestSharedLink1: {
        en: `A link, that opens the radar and enables collaboration on it`,
        fi: `Linkki, jota klikkaamalla kuka tahansa pääsee katsomaan karttaa ja osallistumaan yhteistyöhön`
    },
    RequestSharedLink2: {
        en: `No access to groups’ other content`,
        fi: `Linkillä ei pääse muihin sisältöihin`
    },
    RequestSharedLink3: {
        en: `You can also order an embed code that makes it possible to embed the radar to digital platforms, like to a webpage`,
        fi: `Voi tilata myös upotuskoodin, jonka avulla kartan voi liittää esimerkiksi jollekin verkkosivulle`
    },
    RequestSharedLink4: {
        en: `For data security reasons we recommend to deactivate the shared link when it’s not used anymore`,
        fi: `Tietoturvasyistä suosittelemme jaettavan linkin sulkemista, kun sitä ei enää tarvita`
    },
    RequestSharedLink5: {
        en: `Note: Future Shaper includes one shared link by default. Otherwise it is available as a paid add-on service.`,
        fi: `Huom. Future Shaperiin sisältyy valmiiksi yksi jaettava linkki. Muutoin se on saatavilla maksullisena lisäpalveluna.`
    },
    HoverSharingInfo : {
        en: `More information on Sharing`,
        fi: `Lisätietoja jakamisesta`
    },
    activatedSharedLink : {
        en: `Activate`,
        fi: `Aktivoi`
    },
    expiredTimeSharedLink : {
        en: `Expiration date`,
        fi: `Päättymispäivä`
    },
    yes: {
        en: `Yes`,
        fi: `Kyllä`,
      },
      editHistory: {
        en: `Edit history`,
        fi: `Muokkaa historiaa`,
      },
      editOn: {
        en: `Edited on`,
        fi: `Muokattu`,
      },
      createdby: {
        en: `Created on`,
        fi: `Luotu`,
      },
      by: {
        en: `by`,
        fi: `-`,
      },
      Description: {
        en: `Description`,
        fi: `Kuvaus`,
      },
      Removeevent: {
        en: `Remove event`,
        fi: `Poista tapahtuma`,
      },
      RemoveeventText: {
        en: `Are you sure you want to remove this event permanently from the change log?`,
        fi: `Haluatko varmasti poistaa tämän tapahtuman aikajanalta pysyvästi?`,
      },
      DescriptionMajorChangeLogs: {
        en: `Description for major update`,
        fi: `Kuvaus tehdyistä muutoksista`,
      },
      ShowAsMajorUpdate: {
        en: `Save as major update`,
        fi: `Sisältää merkittäviä muutoksia`,
      },
      Historyandchangelog: {
        en:'History and change log',
        fi: `Historia ja muutokset`,
      },
      ShowHistory: {
        en:'Show history',
        fi: `Näytä historia`,
      },
      HideHistory: {
        en:'Hide history',
        fi: `Kätke historia`,
      },
      relatedScenario: {
        en:'Related scenarios',
        fi: `Liittyvät skenaariot`,
      },
      Created: {
        en:'Created',
        fi: `Luotu`,
      },
      Edited: {
        en:'Edited',
        fi: `Muokattu`,
      },
      on: {
        en:'on',
        fi: `-`,
      },
      editingTextHistory: {
        en:'Write here a brief description why this should be considered as major update.',
        fi: `Tähän voit listata, mitä merkittäviä muutoksia olet tehnyt sisältöön.`,
      },
      lastModified: {
        en: 'Last modified',
        fi: `Päivitetty`,
      },
      phenomena_beyond_sector_radar_main_title: {
        en: 'Some phenomena are outside the visible time range and do not appear on the map.',
        fi: 'Osa ilmiöistä on aikajanan ulkopuolella, eivätkä ne näy kartalla.',
      },
      phenomena_beyond_sector_radar_main_description: {
        en: 'You can adjust the timeline ',
        fi: 'Voit säätää aikajanaa ',
      },
      phenomena_beyond_sector_radar_main_description_link: {
        en: 'here',
        fi: 'tästä',
      },
      infoModalTitle: {
        en: 'Introduction to Radar view',
        fi: 'Ennakointikartta',
      },
      infoModalContentDescription: {
        en: "Foresight radars help you explore the futures. They show important phenomena in a clear, organised way to provide shared understanding of what might be ahead.",
        fi: "Ennakointikartat tarjoavat selkeän tavan tärkeiden tulevaisuuden muutosilmiöiden kokoamiseksi yhteen näkymään yhteisen tulevaisuuskuvan muodostamiseksi."
      },
      infoModalContentPhenomena: {
        en: "<b>Phenomena – the dots on the radar:</b> Click those to learn more:",
        fi: "<b>Muutosilmiöt – pisteet kartalla:</b> Klikkaa auki ja tutustu sisältöön"
      },
      infoModalContentStrengthening: {
        en: "<b>Strengthening –</b> Gaining momentum",
        fi: "<b>Vahvistuva –</b> Muutospotentiaali kasvamassa"
      },
      infoModalContentEstablished: {
        en: "<b>Established –</b> Stable, no big changes expected",
        fi: "<b>Vakiintunut –</b> Vakaa, ei suuria muutoksia odotettavissa"
      },
      infoModalContentWeakening: {
        en: "<b>Weakening –</b> Becoming less relevant",
        fi: "<b>Heikkenevä –</b> Menettää merkitystään"
      },
      infoModalContentWeakSignal: {
        en: "<b>Weak signal –</b> New and uncertain",
        fi: "<b>Heikko signaali –</b> Uusi ja epävarma"
      },
      infoModalContentWildCard: {
        en: "<b>Wild card –</b> Unlikely, but could have big impact",
        fi: "<b>Villi kortti –</b> Epätodennäköinen, mutta voi vaikuttaa voimakkaasti"
      },
      infoModalContentSummary : {
        en: "<b>Summary –</b> Shows the big picture of a broader theme",
        fi: "<b>Yhteenveto –</b> Kokoaa yhteen useampia teemoja"
      },
      infoModalContentNoType: {
        en: "<b>(no type)  –</b> Not yet defined, or deliberately left open",
        fi: "<b>(ei tyyppiä) –</b> Ei määritelty, tai jätetty tarkoituksella avoimeksi"
      },
      infoModalContentTimeRanges: {
        en: "<b>Time ranges:</b> Dots are placed based on when the change is expected to start having an impact.",
        fi: "<b>Aikakehät:</b> Ilmiöt sijaitsevat kartalla sen mukaan, milloin niiden vaikutusten odotetaan alkavan."
      },
      infoModalContentSectors: {
        en: "<b>Sectors:</b> Related topics are grouped together to keep things clear.",
        fi: "<b>Sektorit:</b> Samankaltaiset aiheet on ryhmitelty yhteen selkeyden vuoksi."
      },
      infoModalContentCollaboration: {
        en: "<b>Collaboration:</b> If enabled, you can vote, rate, comment, and discuss on the content cards. Click the centre of the radar to see collaboration results.",
        fi: "<b>Yhteistyö:</b> Jos työkalut yhteistyöhön on aktivoitu, ilmiökortteja avaamalla voit äänestää, arvioida, kommentoida ja keskustella niistä. Kartan keskikohtaa klikkaamalla pääset yhteistyön tuloksiin."
      },
      infoModalContentEditingAndSharing: {
        en: "<b>Editing and sharing:</b> Editors can click the pen icon to edit. Coordinators can also share the radar.",
        fi: "<b>Muokkaaminen ja jakaminen:</b> Käyttäjät. joilla on muokkausoikeudet, voivat klikata kynäikonia ja muokata karttanäkymää. Hallinnointi-tason oikeuksilla voi lisäksi jakaa pääsyoikeuksia kartalle."
      },
      infoModalContentCTA: {
        en: "<a class=\"btn btn-sm btn-outline-secondary text-case-reset\" href=\"https://info.futuresplatform.com/en/hub/foresight-radars\" target=\"_blank\"><span lang=\"EN\">Read more about Foresight radars</span></a>",
        fi: "<a class=\"btn btn-sm btn-outline-secondary text-case-reset\" href=\"https://info.futuresplatform.com/en/hub/foresight-radars\" target=\"_blank\"><span lang=\"FI\">Lue lisää ennakointikartoista (englanniksi)</span></a>"
      },
      
      
}

initTranslations(localTranslations);
